<template>
  <Navbar />
  <ScrollButton />

  <section
    class="banner-title"
    style="background-image: url(images/bizkimiz.png)">
    <div class="auto-container">
      <div class="row clearfix">
        <div class="title-column col-md-6 col-sm-6 col-xs-12">
          <h1>Biz Kimiz</h1>
        </div>
        <div class="col-md-6 col-sm-6 col-xs-12">
          <ul class="bread-crumb clearfix">
            <li>
              <a href="/">Anasayfa</a>
            </li>
            <li class="active">Biz Kimiz</li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <section class="page-container">
    <div class="auto-container">
      <div class="text-content">
        <div class="left-text">
          <blockquote>
            <p>
              Temelleri 1996 yılında atılan firmamız, 2004 yılından itibaren
              <strong>İntek Teknoloji</strong> adıyla elektronik alanındaki faaliyetlerine devam etmektedir.
              Özellikle elektronik kontrol kartları, kumanda kartları ve donanım-yazılım entegrasyonları konusunda
              uzmanlaşmış olan firmamız; Gebze, Kocaeli, Tuzla ve Kartal başta olmak üzere birçok bölgede hizmet vermektedir.
            </p>

            <p class="mt-2">
              Firmamız, müşterilerine yalnızca bir kart devresi değil,
              <strong>kullanıma hazır kit sistemleri</strong> sunar. Bu sistemler; kontrol kartı, güç modülü,
              bağlantı elemanları ve destekleyici yan donanımlarla birlikte teslim edilir.
            </p>

            <p class="mt-2">
              Geliştirdiğimiz kartlar; havalandırma, ısıtma-soğutma, fan kontrolü ve endüstriyel uygulamalar gibi
              alanlarda kullanılmaktadır. Yüksek adetli taleplerde,
              <strong>özel yazılım ve donanım geliştirme</strong> hizmeti de sunulmaktadır.
            </p>

            <p class="mt-2">
              2007 itibarıyla, <strong>İntek Bilişim Teknolojileri</strong> olarak elektronik tasarım ve üretim
              süreçlerini kendi bünyemizde toplamış bulunmaktayız. Böylece dışa bağımlılığı azaltarak,
              daha hızlı ve güvenilir çözümler geliştirebilmekteyiz.
            </p>

            <p class="mt-2">
              Ürünlerimizin tamamı, kendi mühendisliğimiz ve kalite anlayışımızla üretilmektedir.
              Elektronik kart tasarımı, özel yazılım geliştirme, seri üretim ve test süreçleri firmamız bünyesinde yürütülmektedir.
            </p>

            <p class="mt-2">
              Müşteri memnuniyetini ve teknolojik kaliteyi esas alan yaklaşımımız sayesinde,
              birçok firmayla başarılı iş birlikleri gerçekleştirdik.
              Bugün, <strong>elektronik kontrol sistemleri</strong> alanında güvenilir bir çözüm ortağı olmanın gururunu yaşıyoruz.
            </p>
          </blockquote>
        </div>
        <div class="right-img">
          <img class="about-img" src="images/biz-kimiz.png" alt="İntek Electronic üretim tesisi" loading="lazy" />
        </div>
      </div>
    </div>
  </section>

  <Footer />
</template>

<script setup>
import { useHead } from '@vueuse/head';
import Navbar from "@/components/Navbar-2.vue";
import ScrollButton from "@/components/ScrollButton.vue";
import Footer from "@/components/Footer.vue";

useHead({
  title: 'Biz Kimiz - İntek Electronic | Elektronik ve Otomasyon Çözümleri',
  meta: [
    {
      name: 'description',
      content: 'İntek Bilişim Teknolojileri olarak 1996’dan bu yana elektronik kart tasarımı ve otomasyon sistemleri alanında Kocaeli, Gebze, Tuzla ve Kartal bölgelerinde hizmet sunuyoruz.'
    },
    {
      name: 'keywords',
      content: 'intek, intek Bilişim Teknolojileri, elektronik,ısıtma, soğutma, klima kartı, kontrol kartı, intek electronics, elektronik kart tasarımı, otomasyon, kumanda kartı, kocaeli, gebze, tuzla, kartal'
    },
    {
      property: 'og:title',
      content: 'Biz Kimiz - İntek Electronic'
    },
    {
      property: 'og:description',
      content: 'İntek Electronic olarak 1996’dan bu yana elektronik kart tasarımı ve otomasyon sistemleri sunuyoruz.'
    },
    {
      property: 'og:image',
      content: 'https://www.intekelectronic.com.tr/images/about.jpeg'
    }
  ]
});
</script>

<style scoped>

.text-content {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 30px;
  justify-content: center;
  align-items: flex-start;
  margin-top: 40px;
}

.left-text {
  flex: 1 1 400px;
}

.right-img {
  flex: 1 1 320px;
  display: flex;
  justify-content: center;
}

.about-img {
  width: 100%;
  max-width: 460px;
  height: auto;
  border-radius: 8px;
}

/* Mobil uyum */
@media (max-width: 768px) {
  .text-content {
    flex-direction: column;
    align-items: center;
    text-align: left;
  }
}
</style>
